export default function HeaderLogo() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80.8 32.9"><defs></defs><path fill="#008acf" d="M67.5,4.6A13.2,13.2,0,1,0,80.8,17.8,13.21,13.21,0,0,0,67.5,4.6Zm0,21.2a7.9,7.9,0,1,1,8-7.9A7.94,7.94,0,0,1,67.5,25.8Z" /><path fill="#008acf" d="M12.3,5.2H0V30.5H5.4V23.2h7a9,9,0,0,0,9.1-9A9.2,9.2,0,0,0,12.3,5.2Zm0,12.7h-7V10.5h7A3.69,3.69,0,0,1,16,14.2,3.57,3.57,0,0,1,12.3,17.9Z" /><path fill="#008acf" d="M47.2,5.2,38.6,20.9,30,5.2H23.4L38.6,32.9,53.8,5.2Z" /><path fill="#ef7d00" d="M47.2,0,38.6,15.7,30,0Z" /></svg>

    )
}
